export interface ReportData {
  StudentID: string // "2946",
  StudentLastName: string // "Ibrahim",
  StudentFirstName: string // "Farah",
  StudentMI: string | null
  Grade: string //"6",
  StudentGender: string // "M",
  StudentDateOfBirth: string // "12/4/2006",
  StudentEthnicGroup: string // "Not Specified",
  TermName: string // "Spring 2018-2019",
  testResults: TestResult[]
  OrgResidentState?: string
}

export interface StudentData {
  id: number // 2946,
  fullName: string
  grade: string //"6",
  gender: string // "M",
  birthday: string // "12/4/2006",
  ethnicGroup: string // "Not Specified",
  termName: string // "Spring 2018-2019",
  testResults: TestResult[]
}

export interface TestResultGoal {
  name: string
  rit: string
  adjective: string
}

export interface NormalizedSkill {
  name: string
  reinforce: string
  develop: string
  introduce: string
}
export interface SkillSection {
  name: string
  sectionSkills: SkillSectionData[]
}
export interface SkillSectionData {
  reinforce: string
  develop: string
  introduce: string
}

export interface TestResult {
  QuantileMin: string
  QuantileMax: string
  DistrictName: string //"Affordable Homeschool Testing Services LLC",
  SchoolName: string //"Affordable Homeschool Testing Services LLC",
  // old
  MeasurementScale?: string //"Language Usage",
  Discipline?: string //"Language",
  // new
  Course?: string //"Language Usage",
  Subject?: string //"Language",
  NormsReferenceData: string // "2015",
  WISelectedAYFall: string | null
  WISelectedAYWinter: string | null
  WISelectedAYSpring: string | null //"32"
  WIPreviousAYFall: string | null
  WIPreviousAYWinter: string | null
  WIPreviousAYSpring: string | null
  TestType: string // "Survey With Goals"
  TestName: string //"Growth: Math 6+ CCSS 2010 V2"
  TestStartDate: string //"6/7/2019"
  TestDurationMinutes: string //"162"
  TestRITScore: string // "248"
  TestStandardError: string // "3.4"
  TestPercentile: string // "91"
  FallToFallProjectedGrowth: string | null
  FallToFallObservedGrowth: string | null
  FallToFallObservedGrowthSE: string | null
  FallToFallMetProjectedGrowth: string | null
  FallToFallConditionalGrowthIndex: string | null
  FallToFallConditionalGrowthPercentile: string | null
  FallToWinterProjectedGrowth: string | null
  FallToWinterObservedGrowth: string | null
  FallToWinterObservedGrowthSE: string | null
  FallToWinterMetProjectedGrowth: string | null
  FallToWinterConditionalGrowthIndex: string | null
  FallToWinterConditionalGrowthPercentile: string | null
  FallToSpringProjectedGrowth: string | null
  FallToSpringObservedGrowth: string | null
  FallToSpringObservedGrowthSE: string | null
  FallToSpringMetProjectedGrowth: string | null
  FallToSpringConditionalGrowthIndex: string | null
  FallToSpringConditionalGrowthPercentile: string | null
  WinterToWinterProjectedGrowth: string | null
  WinterToWinterObservedGrowth: string | null
  WinterToWinterObservedGrowthSE: string | null
  WinterToWinterMetProjectedGrowth: string | null
  WinterToWinterConditionalGrowthIndex: string | null
  WinterToWinterConditionalGrowthPercentile: string | null
  WinterToSpringProjectedGrowth: string | null
  WinterToSpringObservedGrowth: string | null
  WinterToSpringObservedGrowthSE: string | null
  WinterToSpringMetProjectedGrowth: string | null
  WinterToSpringConditionalGrowthIndex: string | null
  WinterToSpringConditionalGrowthPercentile: string | null
  SpringToSpringProjectedGrowth: string | null
  SpringToSpringObservedGrowth: string | null
  SpringToSpringObservedGrowthSE: string | null
  SpringToSpringMetProjectedGrowth: string | null
  SpringToSpringConditionalGrowthIndex: string | null
  SpringToSpringConditionalGrowthPercentile: string | null
  // old
  RITtoReadingScore?: string | null
  RITtoReadingMin?: string | null
  RITtoReadingMax?: string | null
  // new
  LexileScore?: string | null
  LexileMin?: string | null
  LexileMax?: string | null
  Goal1Name: string | null // "Operations and Algebraic Thinking"
  Goal1RitScore: string | null // "244"
  Goal1StdErr: string | null // "6.6"
  Goal1Range: string | null // "237-251"
  Goal1Adjective: string | null // "High"
  Goal2Name: string | null // "The Real and Complex Number Systems"
  Goal2RitScore: string | null // "246"
  Goal2StdErr: string | null // "7.2"
  Goal2Range: string | null // "239-253"
  Goal2Adjective: string | null // "High"
  Goal3Name: string | null // "Geometry"
  Goal3RitScore: string | null // "240"
  Goal3StdErr: string | null // "7.2"
  Goal3Range: string | null // "233-247"
  Goal3Adjective: string | null // "HiAvg"
  Goal4Name: string | null // "Statistics and Probability"
  Goal4RitScore: string | null // "259"
  Goal4StdErr: string | null // "7.3"
  Goal4Range: string | null // "252-266"
  Goal4Adjective: string | null // "High"
  Goal5Name: string | null
  Goal5RitScore: string | null
  Goal5StdErr: string | null
  Goal5Range: string | null
  Goal5Adjective: string | null
  Goal6Name: string | null
  Goal6RitScore: string | null
  Goal6StdErr: string | null
  Goal6Range: string | null
  Goal6Adjective: string | null
  Goal7Name: string | null
  Goal7RitScore: string | null
  Goal7StdErr: string | null
  Goal7Range: string | null
  Goal7Adjective: string | null
  Goal8Name: string | null
  Goal8RitScore: string | null
  Goal8StdErr: string | null
  Goal8Range: string | null
  Goal8Adjective: string | null
  TestStartTime: string // "12:58:20"
  PercentCorrect: string // "64"
  ProjectedProficiencyStudy1: string | null // "ACT College Readiness"
  ProjectedProficiencyLevel1: string | null // "On Track 24"
  ProjectedProficiencyStudy2: string | null // "Minnesota Comprehensive Assessments-Series III"
  ProjectedProficiencyLevel2: string | null // "Exceeds"
  ProjectedProficiencyStudy3: string | null // "SAT"
  ProjectedProficiencyLevel3: string | null // "On Track"
  AccommodationCategory: string | null
  Accommodations: string | null
  TypicalFallToFallGrowth: string | null
  TypicalFallToWinterGrowth: string | null
  TypicalFallToSpringGrowth: string | null
  TypicalWinterToWinterGrowth: string | null
  TypicalWinterToSpringGrowth: string | null
  TypicalSpringToSpringGrowth: string | null // "3"
  ProjectedProficiencyStudy4: string | null
  ProjectedProficiencyLevel4: string | null
  ProjectedProficiencyStudy5: string | null
  ProjectedProficiencyLevel5: string | null
  ProjectedProficiencyStudy6: string | null
  ProjectedProficiencyLevel6: string | null
  ProjectedProficiencyStudy7: string | null
  ProjectedProficiencyLevel7: string | null
  ProjectedProficiencyStudy8: string | null
  ProjectedProficiencyLevel8: string | null
  ProjectedProficiencyStudy9: string | null
  ProjectedProficiencyLevel9: string | null
  ProjectedProficiencyStudy10: string | null
  ProjectedProficiencyLevel10: string | null
  TypicalOf: string // "12"
  MaxGrowth: number | null //10
}

export interface RawTestResult extends TestResult {
  StudentID: string // "2946",
  StudentLastName: string // "Ibrahim",
  StudentFirstName: string // "Farah",
  StudentMI: string | null
  Grade: string //"6",
  StudentGender: string // "M",
  StudentDateOfBirth: string // "12/4/2006",
  StudentEthnicGroup: string // "Not Specified",
  TermName: string // "Spring 2018-2019",
}

export interface ChartStudent {
  id: number
  fullName: string
  testResults: ChartTestResult[]
  color: string | null
}

export interface ChartTestResult {
  Grade: string
  TermName: string
  TestRITScore: string
  TestPercentile: string
  Course?: string
  MeasurementScale?: string
  Subject?: string
  Discipline?: string
  isCurrent?: boolean
}

export interface ChartOralTestResult {
  Grade: string
  TermName: string
  TestPercentile?: string
  score?: string
  isCurrent?: boolean
}

export const isChartTestResult = (testResult: any): testResult is ChartTestResult =>
  (testResult as ChartTestResult).Grade !== undefined

export const isChartOralTestResult = (testResult: any): testResult is ChartOralTestResult =>
  (testResult as ChartOralTestResult).Grade !== undefined

export interface FluencyTestResultRaw {
  TermName: string // Fall 2023-2024
  DistrictName: string // Affordable homeschool testing services llc
  SchoolName: string // HomeschoolBoss
  StudentID: string // 44120
  StudentFirstName: string // "Farah",
  StudentLastName: string // "Ibrahim",
  StudentMI: string | null
  StudentDateOfBirth: string
  StudentGender: string // "M",
  StudentEthnicGroup: string
  Grade: string // 3
  AssignedTestType: string //Adaptive Oral Reading
  ResultType: string // Oral Reading / Dyslexia Screener
  TestLanguage: string // English
  TestCompletionDate: string // 10/02/2023
  ListeningComprehensionCorrect: string | null //15
  ListeningComprehensionAttempted: string | null // 15
  ListeningComprehensionPerformanceLevel: string | null // Meets Expectation
  PictureVocabCorrect: string | null // 15
  PictureVocabAttempted: string | null // 15
  PictureVocabPerformanceLevel: string | null // Meets Expectation
  PhonologicalAwarenessDomainScore: string | null // 532
  PhonologicalAwarenessTestPercentile: string | null // 99
  PhonologicalAwarenessZPDName: string | null // Reinforce - Phonemic Manipulation
  PhonologicalAwarenessZPDLevel: string | null // 5
  PhonologicalAwarenessPerformanceLevel: string | null // Below Expectation
  PhonicsWordRecognitionDomainScore: string | null // 535
  PhonicsWordRecognitionTestPercentile: string | null // 99
  PhonicsWordRecognitionZPDName: string | null // Reinforce - Decodable: One-syllable
  PhonicsWordRecognitionZPDLevel: string | null // 5
  PhonicsWordRecognitionPerformanceLevel: string | null // Below Expectation
  LanguageComprehensionDomainScore: string | null // 519
  LanguageComprehensionTestPercentile: string | null // 99
  SentenceReadingFluencyCorrect: string // 40
  SentenceReadingFluencyAttempted: string // 40
  SentenceReadingFluencyPerformanceLevel: string // Meets Expectation
  OralReadingRatePerformanceLevel: string | null // Exceeds Expectation
  OralReadingWCPMScaled: string | null // 126
  OralReadingAccuracyPerformanceLevel: string | null // Approaching Expectation
  OralReadingAccuracyScore: string | null // 0.92
  LiteralComprehensionPerformanceLevel: string | null // Exceeds Expectation
  LexileOralReadingMeasure: string | null // 545L
  DyslexiaScreenerOutcome: string // N/A or  Not Flagged
  RANDurationOverallScore: string | null // 33
  RANPicturesCorrectPerSecondOverallScore: string | null // 1.1
  RANDurationPage1: string | null // 17
  RANPicturesCorrectPerSecondPage1: string | null // 1.08
  RANDurationPage2: string | null // 16
  RANPicturesCorrectPerSecondPage2: string | null // 1.12
  UniversalScreenerOutcome: string // NotFlagged or N/A
}

export interface FluencyChartStudent {
  id: number
  studentName: string
  testFluencyChart: ChartOralTestResult[]
  color: string | null
}
